module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "凭证关联人",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "disabled": "true",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发票代码",
      "prop": "code"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "placeholder": "请输入发票代码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发票号码",
      "prop": "number"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "placeholder": "请输入发票号码"
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "往来单位",
      "prop": "unit"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "placeholder": "请输入往来单位"
    },
    model: {
      value: (_vm.form.unit),
      callback: function($$v) {
        _vm.$set(_vm.form, "unit", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "不含税金额",
      "prop": "no_tax_money"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "placeholder": "请输入不含税金额"
    },
    model: {
      value: (_vm.form.no_tax_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "no_tax_money", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.no_tax_money"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "税额",
      "prop": "tax_money"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "placeholder": "请输入税额"
    },
    model: {
      value: (_vm.form.tax_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "tax_money", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.tax_money"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价税合计金额",
      "prop": "money"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-500",
    attrs: {
      "placeholder": "请输入价税合计金额"
    },
    model: {
      value: (_vm.form.money),
      callback: function($$v) {
        _vm.$set(_vm.form, "money", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.money"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票日期",
      "prop": "day"
    }
  }, [_c('el-date-picker', {
    staticClass: "h-40 w-500",
    attrs: {
      "type": "date",
      "placeholder": "开票日期"
    },
    model: {
      value: (_vm.form.day),
      callback: function($$v) {
        _vm.$set(_vm.form, "day", $$v)
      },
      expression: "form.day"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发票文件"
    }
  }, [(_vm.form.url.indexOf('pdf') != -1) ? _c('object', {
    attrs: {
      "data": _vm.form.url,
      "type": "application/pdf",
      "width": "500px",
      "height": "388px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.url.indexOf('ofd') != -1) ? _c('div', {
    staticStyle: {
      "color": "#111",
      "line-height": "50px",
      "text-alias": "center"
    },
    attrs: {
      "type": "application/pdf",
      "width": "100px",
      "height": "50px"
    }
  }, [_vm._v("你已上传ofd文件，暂不支持查看")]) : _vm._e(), _vm._v(" "), (_vm.form.url.indexOf('jpg') != -1 || _vm.form.url.indexOf('jpeg') != -1 || _vm.form.url.indexOf('png') != -1) ? _c('el-popover', {
    attrs: {
      "placement": "left-end",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.url,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-r-10",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference",
      "src": _vm.form.url,
      "width": "150",
      "height": "100"
    },
    slot: "reference"
  })]) : _vm._e(), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": _vm.uploadUrl,
      "type": "drag",
      "thumbnail-mode": true,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "show-file-list": "false"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传  pdf / ofd / jpg / png文件")])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cca545f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/invoice/edit.vue
// module id = 1840
// module chunks = 2